import React from 'react';
import { PortfolioItem } from '@/hooks/useProfile';
import { ScrollArea } from '@/components/ui/scroll-area';
import { RichTextDisplay } from '@/components/ui/rich-text-display';

interface MobileDescriptionTabProps {
  item: PortfolioItem;
}

const MobileDescriptionTab = ({ item }: MobileDescriptionTabProps) => {
  return (
    <ScrollArea className="h-full">
      <div className="p-4 space-y-4">
        {/* Title */}
        <div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h2>
          
          {/* Project metadata */}
          {item.created_at && (
            <div className="text-xs text-gray-500 mb-4">
              <p>Created: {new Date(item.created_at).toLocaleDateString()}</p>
            </div>
          )}
        </div>

        {/* Description */}
        <div className="prose prose-sm max-w-none">
          <RichTextDisplay 
            content={item.description || 'No description provided.'} 
          />
        </div>

        {/* Additional metadata can be added here if needed */}
      </div>
    </ScrollArea>
  );
};

export default MobileDescriptionTab; 